import React, { useEffect, useState } from 'react';
import './SideBar.css';
import SideNavItem from './side-nav-item/SideNavItem';
import { useSelector } from 'react-redux';

function SideBar(props) {
  const {
    match: { url },
    location,
  } = props;
  const { lang } = useSelector((state) => state.langReducer);
  const { selectedOrganization } = useSelector(
    (state) => state.organizationReducer
  );

  const [adminNavigation, setAdminNavigation] = useState([]);

  useEffect(() => {
    let adminNavs = [
      {
        displayName: lang.Dashboard,
        route: `${url}/dashboard`,
        icon: <i className="fas fa-tachometer-alt" />,
        children: [],
      },
      {
        displayName: lang.GroupManagement,
        icon: <i className="far fa-object-group" />,
        children: [
          {
            displayName: lang.AllGroups,
            route: `${url}/groups`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
          {
            displayName: lang.AddGroup,
            route: `${url}/groups/add`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
        ],
      },
      {
        displayName: lang.OutletManagement,
        icon: <i className="fas fa-location-arrow" />,
        children: [
          {
            displayName: lang.AllOutlets,
            route: `${url}/outlets`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
          {
            displayName: lang.AddOutlet,
            route: `${url}/outlets/add`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
        ],
      },
      {
        displayName: lang.EmployeesManagement,
        icon: <i className="fas fa-users" />,
        children: [
          {
            displayName: lang.AllEmployees,
            route: `${url}/employees`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
          {
            displayName: lang.AddEmployee,
            route: `${url}/employees/add`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
        ],
      },
      {
        displayName: lang.Announcements,
        icon: <i className="far fa-bell" />,
        children: [
          {
            displayName: lang.AllAnnouncements,
            route: `${url}/announcements`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
          {
            displayName: 'Add Announcement',
            route: `${url}/announcements/add`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
        ],
      },
      {
        key: 'attendance-management',
        displayName: lang.AttendanceManagement,
        icon: <i className="fas fa-hourglass-half" />,
        children: [
          {
            displayName: lang.All,
            route: `${url}/attendances/all`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
          {
            displayName: lang.Flagged,
            route: `${url}/attendance/flagged`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
          {
            displayName: lang.Pending,
            route: `${url}/attendance/pending`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
          // {
          //     displayName: lang.PendingApprovals,
          //     route: `${url}/attendances/pending`,
          //     icon: <i className="far fa-circle"/>,
          //     children: []
          // },
          // {
          //     displayName: lang.Approved,
          //     route: `${url}/attendances/approved`,
          //     icon: <i className="far fa-circle"/>,
          //     children: []
          // },
          // {
          //     key: "pending-ack-approval",
          //     displayName: lang.PendingAckApproval,
          //     route: `${url}/attendance/pending-pending-acknowledgements`,
          //     icon: <i className="far fa-circle"/>,
          //     children: []
          // },

          {
            displayName: lang.Settings,
            icon: <i className="fas fa-cogs" />,
            route: `${url}/attendance/settings`,
            children: [],
          },
        ],
      },
      {
        displayName: lang.ContentManagement,
        icon: <i className="fas fa-stream" />,
        children: [
          {
            displayName: lang.AllContents,
            route: `${url}/contents`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
          {
            displayName: lang.AddContent,
            route: `${url}/contents/add`,
            icon: <i className="far fa-circle" />,
            children: [],
          },
        ],
      },
      {
        displayName: lang.ActivityLogs,
        route: `${url}/activity-logs`,
        icon: <i className="fas fa-list-ul" />,
        children: [],
      },
      {
        displayName: lang.OrgSettings,
        icon: <i className="fas fa-cogs" />,
        route: `${url}/settings`,
        children: [],
      },
    ];

    adminNavs = adminNavs.map((nav) => {
      if (nav.key === 'attendance-management') {
        if (!selectedOrganization.verifyEachAttendance) {
          nav.children = nav.children.filter(
            (child) => child.key !== 'pending-ack-approval'
          );
          return nav;
        }
      }
      return nav;
    });
    setAdminNavigation(adminNavs);
  }, [selectedOrganization, lang, url]);

  const userNavigation = [
    {
      displayName: lang.Dashboard,
      route: `${url}/dashboard`,
      icon: <i className="fas fa-tachometer-alt" />,
      children: [],
    },
    {
      displayName: lang.Attendance,
      icon: <i className="fas fa-hourglass-half" />,
      children: [
        {
          displayName: 'Me',
          route: `${url}/attendance/own`,
          icon: <i className="far fa-circle" />,
          children: [],
        },
        {
          displayName: 'My subs',
          route: `${url}/attendance/mysub`,
          icon: <i className="far fa-circle" />,
          children: [],
        },
        {
          displayName: 'My outlet',
          route: `${url}/attendance/myoutlet`,
          icon: <i className="far fa-circle" />,
          children: [],
        },
        {
          displayName: 'My group',
          route: `${url}/attendance/mygroup`,
          icon: <i className="far fa-circle" />,
          children: [],
        },
      ],
    },
    {
      displayName: lang.Announcements,
      route: `${url}/announcements`,
      icon: <i className="far fa-bell" />,
      children: [],
    },
    {
      displayName: lang.ActivityLogs,
      route: `${url}/activity-logs`,
      icon: <i className="fas fa-list-ul" />,
      children: [],
    },
  ];

  return (
    <div className="sidebar-bg border-right" id="sidebar-wrapper">
      <div className="sidebar-heading">
        <h4 className="mb-0">Attendance</h4>
        <small className="version">
          Version 0.1.2.9 <span className="badge badge-primary">Beta</span>
        </small>
        {location.pathname.includes('admin') && <h6 className="mt-1">Admin</h6>}
      </div>
      <ul className="list-unstyled nav-ul">
        {location.pathname.includes('admin') &&
          adminNavigation.map((nav, index) => (
            <SideNavItem navItem={nav} key={`${nav.displayName}${index}`} />
          ))}

        {location.pathname.includes('user') &&
          userNavigation.map((nav, index) => (
            <SideNavItem navItem={nav} key={`${nav.displayName}${index}`} />
          ))}
      </ul>
    </div>
  );
}

export default SideBar;
